import { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useModal } from './ModalProvider';
import ProfileModal from './ProfileModal';
import ThemeToggle from './ThemeToggle';
import AccentPicker from './AccentPicker';
import SidebarPicker from './SidebarPicker';
import FxToggle from './FxToggle';
import { roleName } from '../utils/format';
import { attPendingCount } from '../api/attendance';

// Menu gom theo nhóm (Phương án A — theo phòng ban/chức năng). Icon dùng Tabler line.
const NAV_GROUPS = [
  {
    title: 'TỔNG QUAN',
    items: [{ key: 'dashboard', ico: 'ti-layout-dashboard', label: 'Trang chủ', roles: ['GD', 'TP', 'NV'] }],
  },
  {
    title: 'KINH DOANH',
    items: [
      // Danh sách quét: chỉ GĐ/CV + TRƯỞNG PHÒNG nhóm kinh doanh. NV và Phòng DVKH không xem.
      { key: 'scan', ico: 'ti-list-search', label: 'Danh sách quét', roles: ['GD', 'TP'], salesTP: true },
      { key: 'tasks', ico: 'ti-checklist', label: 'Công việc', roles: ['GD', 'TP', 'NV'] },
      // CSKH: nhân sự Kinh doanh + Phòng CSKH xem được; ẩn với kế toán/DVKH THUẦN (không kiêm CSKH).
      { key: 'cskh', ico: 'ti-headset', label: 'CSKH', roles: ['GD', 'TP', 'NV'], notDept: ['Phòng kế toán', 'Phòng DVKH'], ownDept: 'Phòng CSKH' },
      { key: 'customers', ico: 'ti-users', label: 'Khách hàng', roles: ['GD', 'TP', 'NV'], notDept: 'Phòng kế toán' },
      { key: 'refund', ico: 'ti-receipt-refund', label: 'Đề xuất hoàn tiền', roles: ['GD', 'TP', 'NV'], refund: true },
    ],
  },
  {
    title: 'NHÂN SỰ & KPI',
    items: [
      { key: 'staff', ico: 'ti-user-cog', label: 'Nhân viên', roles: ['GD'] },
      // Bảng lương CÁ NHÂN nằm ở tab "Bảng lương" trong KPI. Mục này là QUẢN LÝ toàn bộ NV — chỉ
      // GĐ/CV + Kế toán trưởng (payrollAdmin) thấy.
      { key: 'payroll', ico: 'ti-report-money', label: 'Quản lý bảng lương', roles: ['GD', 'TP', 'NV'], payrollAdmin: true },
      // Nhật ký trao đổi nội bộ: GĐ/CV + nhân sự Phòng CSKH (xem toàn bộ).
      { key: 'exchange-log', ico: 'ti-history', label: 'Nhật ký trao đổi', roles: ['GD', 'TP', 'NV'], dept: 'Phòng CSKH' },
      { key: 'kpi', ico: 'ti-chart-bar', label: 'KPI', roles: ['GD', 'TP', 'NV'] },
      // Lịch trực DVKH: Giám đốc + nhân viên thuộc phòng DVKH (30.000đ/giờ).
      { key: 'overtime', ico: 'ti-calendar-clock', label: 'Lịch trực DVKH', roles: ['GD', 'TP', 'NV'], dept: 'Phòng DVKH' },
      // Lịch trực Kế toán: Giám đốc + nhân viên thuộc phòng Kế toán (10.000đ/giờ).
      { key: 'overtime-ketoan', ico: 'ti-calendar-clock', label: 'Lịch trực Kế toán', roles: ['GD', 'TP', 'NV'], dept: 'Phòng kế toán' },
    ],
  },
  {
    title: 'BÁO CÁO',
    items: [
      // Báo cáo tuần (tổng hợp trạng thái nộp các phòng): GĐ/CV + role TP + trưởng phòng ban.
      { key: 'weekly-report', ico: 'ti-calendar-stats', label: 'Báo cáo tuần', roles: ['GD', 'TP', 'NV'], allTP: true },
      { key: 'purchase-report', ico: 'ti-shopping-cart', label: 'Báo cáo mua hàng', roles: ['GD', 'TP', 'NV'] },
      { key: 'business-report', ico: 'ti-trending-up', label: 'Báo cáo kinh doanh', roles: ['GD', 'TP', 'NV'], salesTP: true },
      { key: 'cskh-report', ico: 'ti-headset', label: 'Báo cáo CSKH', roles: ['GD', 'TP', 'NV'], allTP: true, ownDept: 'Phòng CSKH' },
      { key: 'finance-report', ico: 'ti-coin', label: 'Báo cáo tài chính', roles: ['GD', 'TP', 'NV'], allTP: true, ownDept: 'Phòng kế toán' },
      { key: 'meetings', ico: 'ti-calendar-event', label: 'Biên bản họp', roles: ['GD', 'TP', 'NV'], meeting: true },
    ],
  },
  {
    title: 'NỘI BỘ',
    items: [
      { key: 'announcements', ico: 'ti-bell', label: 'Thông báo', roles: ['GD', 'TP', 'NV'] },
      { key: 'notes', ico: 'ti-notebook', label: 'Ghi chú', roles: ['GD', 'TP', 'NV'] },
      // Lionjob (CHỈ Giám đốc + mã code) — 1 mục; 2 màn (Scraped Products / Listing Task) là tab bên trong.
      { key: 'lionjob', ico: 'ti-paw', label: 'Lionjob', roles: ['GD'], gdOnly: true },
    ],
  },
  {
    title: 'GIẢI TRÍ',
    items: [{ key: 'cangua', ico: 'ti-dice', label: 'Cá Ngựa', roles: ['GD', 'TP', 'NV'] }],
  },
  {
    title: 'HỆ THỐNG',
    // Đồng bộ: GĐ/CV toàn quyền; Trưởng phòng KD (role TP có nhóm) chỉ thấy 2 lệnh quét đơn hàng.
    items: [{ key: 'sync', ico: 'ti-refresh', label: 'Đồng bộ', roles: ['GD', 'TP'], salesTP: true }],
  },
];

export default function Sidebar({ page, setPage }) {
  const { me, logout } = useAuth();
  const { openModal, closeModal } = useModal();
  const [collapsed, setCollapsed] = useState(() => localStorage.getItem('ft_sidebar_collapsed') === '1');
  const [attPending, setAttPending] = useState(0); // đơn chấm công chờ duyệt -> chấm đỏ ở menu KPI

  useEffect(() => {
    document.body.classList.toggle('sidebar-collapsed', collapsed);
    localStorage.setItem('ft_sidebar_collapsed', collapsed ? '1' : '0');
  }, [collapsed]);

  // Đếm đơn chấm công chờ duyệt (làm mới khi đổi trang + định kỳ 90s).
  useEffect(() => {
    let alive = true;
    const tick = () => attPendingCount().then((d) => alive && setAttPending(d.count || 0)).catch(() => {});
    tick();
    const id = setInterval(tick, 90000);
    return () => { alive = false; clearInterval(id); };
  }, [page]);

  // Hiển thị nav: theo vai trò; mục có "dept" thì cần GĐ hoặc thuộc phòng ban đó.
  const isAdminRole = me.role === 'GD' || me.role === 'CV';
  const isDeptHead = (me.deptHeadOf || []).length > 0; // trưởng phòng ban (kể cả role NV)
  const isOpHead = (me.deptHeadOf || []).includes('Phòng OP'); // trưởng phòng OP: ẩn các báo cáo (trừ Biên bản họp)
  const REPORT_KEYS = ['weekly-report', 'purchase-report', 'business-report', 'cskh-report', 'finance-report'];
  const canSee = (i) => {
    // Mục gdOnly (vd Lionjob): CHỈ một mình Giám đốc (role GD) — chặn trước cả short-circuit CV.
    if (i.gdOnly) return me.role === 'GD';
    // GĐ/CV (Cố vấn) toàn quyền: thấy mọi mục (CV không nằm trong roles của item nên phải bỏ qua sớm).
    if (isAdminRole) return true;
    // Trưởng phòng OP: ẩn toàn bộ báo cáo, chỉ giữ Biên bản họp.
    if (isOpHead && REPORT_KEYS.includes(i.key)) return false;
    if (!i.roles.includes(me.role)) return false;
    // Ẩn với thành viên phòng ban bị chặn (vd Phòng kế toán/DVKH không xem CSKH),
    // NHƯNG nếu kiêm phòng SỞ HỮU module (ownDept) thì vẫn xem được ("thuộc phòng nào có quyền phòng đó").
    if (i.notDept && !isAdminRole) {
      const blockedDepts = Array.isArray(i.notDept) ? i.notDept : [i.notDept];
      const inBlocked = blockedDepts.some((d) => (me.departments || []).includes(d));
      const inOwn = i.ownDept && (me.departments || []).includes(i.ownDept);
      if (inBlocked && !inOwn) return false;
    }
    // Báo cáo: GĐ/CV + mọi role TP + mọi TRƯỞNG PHÒNG BAN đều xem được của nhau (NV thường không).
    if (i.allTP) return isAdminRole || me.role === 'TP' || isDeptHead || (i.ownDept && (me.departments || []).includes(i.ownDept));
    // Báo cáo kinh doanh: GĐ/CV + TRƯỞNG PHÒNG KINH DOANH (role TP có nhóm) + trưởng phòng ban.
    if (i.salesTP) return isAdminRole || (me.role === 'TP' && !!me.group) || isDeptHead;
    // Biên bản họp: GĐ/CV + role TP + trưởng phòng ban + thành viên Phòng CSKH (người ghi).
    if (i.meeting) return isAdminRole || me.role === 'TP' || isDeptHead || (me.departments || []).includes('Phòng CSKH');
    // Bảng lương tổng hợp: GĐ/CV + Kế toán trưởng (trưởng phòng "Phòng kế toán").
    if (i.payrollAdmin) return isAdminRole || (me.deptHeadOf || []).includes('Phòng kế toán');
    // Đề xuất hoàn tiền: NV/TP Kinh doanh + TP DVKH + Kế toán trưởng + GĐ.
    if (i.refund) return isAdminRole || (me.departments || []).includes('Phòng kinh doanh') || (me.deptHeadOf || []).includes('Phòng DVKH') || (me.deptHeadOf || []).includes('Phòng kế toán');
    if (i.headDept) return isAdminRole || (me.deptHeadOf || []).includes(i.headDept);
    if (i.dept) return me.role === 'GD' || (me.departments || []).includes(i.dept);
    return true;
  };

  return (
    <aside className="sidebar">
      <div className="brand">
        <img className="logo" src="/icon.svg" alt="FunnyTask" />
        <div className="brand-text">
          <h1>FunnyTask</h1>
          <div className="by">By Vũ Duy Khánh</div>
        </div>
        <button className="side-collapse" onClick={() => setCollapsed((v) => !v)} title={collapsed ? 'Mở rộng' : 'Thu gọn'}>
          {collapsed ? '»' : '«'}
        </button>
      </div>
      <nav className="nav">
        {NAV_GROUPS.map((g) => {
          const items = g.items.filter(canSee);
          if (!items.length) return null;
          return (
            <div className="nav-group" key={g.title}>
              <div className="nav-title">{g.title}</div>
              {items.map((i) => (
                <button
                  key={i.key}
                  className={page === i.key ? 'active' : ''}
                  onClick={() => setPage(i.key)}
                  title={i.key === 'kpi' && attPending > 0 ? `${i.label} · ${attPending} đơn chấm công chờ duyệt` : i.label}
                  style={i.key === 'kpi' ? { position: 'relative' } : undefined}
                >
                  <i className={`ti ${i.ico} ico`} aria-hidden="true"></i> <span className="nav-label">{i.label}</span>
                  {i.key === 'kpi' && attPending > 0 && <span style={{ position: 'absolute', top: 8, right: 10, width: 8, height: 8, borderRadius: '50%', background: 'var(--danger)' }} />}
                </button>
              ))}
            </div>
          );
        })}
      </nav>
      <div className="side-foot">
        <div className="who">
          <div className="name">{me.name}</div>
          <div className="role">{me.group?.name || 'Ban giám đốc'}</div>
          <span className={`role-badge ${{ GD: 'role-gd', CV: 'role-cv', TP: 'role-tp', NV: 'role-nv' }[me.displayRole || me.role]}`}>
            {roleName(me.displayRole || me.role)}
          </span>
        </div>
        <button
          className="btn ghost sm"
          style={{ width: '100%', marginTop: 8 }}
          onClick={() => openModal(<ProfileModal onClose={closeModal} />)}
        >
          ⚙️ Đổi thông tin
        </button>
        <ThemeToggle />
        <FxToggle />
        <AccentPicker />
        <SidebarPicker />
        <button className="btn ghost sm" style={{ width: '100%', marginTop: 6 }} onClick={logout}>
          Đăng xuất
        </button>
      </div>
    </aside>
  );
}
